import React from "react";
import { Spinner } from "react-bootstrap";
import { useState } from "react";
import { useShowContract } from "../Hooks/index";
function Index({ getData }) {
  const [tracking, setTracking] = useState();
  const { loading, data } = useShowContract();
  return (
    <>


      <div className="logobar">
        <div>
          <img src={window.location.origin + "/img/logo/logo2.png"} width={'80px'} height={'80px'} />
        </div>
        <div className="mt-1">
          <h6 >نیکوتن</h6>
          <h6  >سامانه رزرو آنلاین ورزشی</h6>
        </div>
      </div>
      <div className="row justify-content-evenly mt-4">
        <div className="col d-flex justify-content-center align-items-center">
          <div>
            <input
              type="text"
              placeholder="کد پیگیری"
              className="form-control input-search-item"
              onChange={e => {
                setTracking(e.target.value);
              }}
              onKeyDown={e => {
                if (e.key == "Enter") {
                  getData(tracking);
                }
              }}
            // style={{ color: "#000" }}
            />
          </div>
          <div style={{ marginRight: "10px" }}>
            <button
              type="button"
              className="btn btn-danger d-flex align-items-center justify-content-center"
              style={{ padding: "10px", borderRadius: "10px" }}
              onClick={e => {
                getData(tracking);
              }}
            >
              {loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <i className="fas fa-search"></i>
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="mt-4 menu-textbox">
        <h6>برای مشاهده ی جزییات قراردادتان کد پیگیری را وارد کنید .</h6>
      </div>
    </>
  );
}

export default Index;
